module.exports = __webpack_public_path__ + "static/img/sf2.a8aa1d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sf2.png
// module id = uUaL
// module chunks = 1